<template>
    <nav>
        <ul class="nav">
            <li>
                <router-link class="sidebar-link color-purple" to="/" exact>
                    <i class="fal fa-tachometer-alt-average" />
                    <span class="sidebar-link-text">Dashboard</span>
                </router-link>
            </li>
            <li>
                <router-link class="sidebar-link color-blue" to="/shows">
                    <i class="fal fa-microphone" />
                    <span class="sidebar-link-text">Shows</span>
                </router-link>
            </li>
            <li>
                <router-link class="sidebar-link color-red" to="/platforms">
                    <i class="fal fa-plug" />
                        <span class="sidebar-link-text">Platforms</span>
                </router-link>
            </li>
            <sidebar-shows />
        </ul>
    </nav>
</template>

<script>
import SidebarShows from './SidebarShows';

export default {
    components: {
        SidebarShows,
    },
};
</script>
